import { Card, CardHeader, Pagination } from "@mui/material";
import UsersApi from "Classes/API/UsersApi";
import SearchUserModel from "Classes/Models/Requests/Users/SearchUser";
import Loader from "Loader";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import React, { useEffect, useState, useContext } from "react";
import { LanguageContext } from "App";
import { useNavigate } from "react-router-dom";
import AsyncSelect from "react-select/async";
const AccountingSessionWithNoPatientHistoryEntry = () => {
  const navigate = useNavigate();
  function handleOnClick(url) {
    navigate(url, { replace: true }), [navigate];
  }
  const [
    AccountingSessionWithNoPatientHistoryEntry,
    setAccountingSessionWithNoPatientHistoryEntry,
  ] = useState([]);
  const [PaginationPages, setPaginationPages] = useState(0);
  const [Page, setPage] = useState(1);

  const [PatientSearch, setPatientSearch] = useState("");
  const [Name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const { translations } = useContext(LanguageContext);

  const [OptionPatient, setOptionPatient] = useState([]);

  useEffect(() => {
    GetPatients().then((res) => {
      setOptionPatient(res);
    });
  }, [PatientSearch]);

  const GetPatients = async (inputValue = "") => {
    let searchReq = new SearchUserModel();
    searchReq.userType = "Therapist";
    searchReq.name = inputValue;
    searchReq.pagingParams.pageNumber = Page;
    searchReq.pagingParams.pageSize = 10;

    console.log(searchReq);
    let res = await UsersApi.SearchUsers(searchReq);

    if (res.status == "Success") {
      console.log(res);
      let optionsArr = res.data.list.map((item) => ({
        value: item.name,
        label: item.name,
      }));
      console.log(optionsArr);
      if (inputValue) {
        optionsArr = optionsArr.filter((item) =>
          item.label.toLowerCase().includes(inputValue.toLowerCase())
        );
      }
      return optionsArr;
    }
    return [];
  };

  const getAccountingSessionWithNoPatientHistoryEntry = async () => {
    try {
      var req = new SearchUserModel();
      req.SearchString = Name;
      req.pagingParams.pageNumber = Page;
      req.pagingParams.pageSize = 10;

      UsersApi.SearchAccountingSessionWithNoPatientHistoryEntry(req).then((res) => {
        console.log(res.data);
        setPaginationPages(res.data.totalPages);
        setAccountingSessionWithNoPatientHistoryEntry(res.data.list);
        setLoading(false);
      });
    } catch (error) {
      console.error("Error fetching patient data:", error);
    }
  };

  useEffect(() => {
    setLoading(true);
    getAccountingSessionWithNoPatientHistoryEntry();
  }, [Name]);

  useEffect(() => {
    setLoading(true);
    getAccountingSessionWithNoPatientHistoryEntry();
  }, [Page]);

  return (
    <DashboardLayout>
      <div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <Card sx={{ padding: "1em", margin: "1em 0 0 0" }}>
                <CardHeader title={translations.Filter} />
                <MDBox mb={3}>
                  <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                    {translations.sessionWithoutEnteriesTherapistName}: &nbsp;
                  </MDTypography>

                  <MDTypography
                    className="col-md-4"
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    style={{ width: "50px" }}
                  >
                    <AsyncSelect
                      isClearable={true}
                      loadOptions={(inputValue) => GetPatients(inputValue)}
                      defaultOptions={OptionPatient}
                      onChange={(e) => setName(e ? e.value : "")}
                    />
                  </MDTypography>
                </MDBox>
              </Card>
            </div>

            <div className="col-md-12">
              {loading ? (
                <Loader />
              ) : (
                <Card className="mt-5">
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    sx={{ backgroundColor: "#3560AD" }}
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                    textAlign="center"
                  >
                    <MDTypography variant="h6" color="white">
                      {translations.sessionWithoutEnteriesAccountingsessionswithoutmedicalnotes}
                    </MDTypography>
                  </MDBox>
                  <MDBox p={3}>
                    <table
                      className="table bordered"
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        marginTop: "20px",
                        fontSize: "14px",
                      }}
                    >
                      <thead>
                        <tr style={{ borderBottom: "1px solid #ddd" }}>
                          <th>{translations.sessionWithoutEnteriesid}</th>
                          <th>{translations.sessionWithoutEnteriesSessionName}</th>
                          <th>{translations.sessionWithoutEnteriesPatientname}</th>
                          <th>{translations.sessionWithoutEnteriesdoctorName}</th>
                          <th>{translations.sessionWithoutEnteriesAppointmentTime}</th>
                          <th>{translations.sessionWithoutEnteriesAddHistoryEntries}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {AccountingSessionWithNoPatientHistoryEntry.map((acc, index) => (
                          <tr key={acc.id} style={{ borderBottom: "1px solid #ddd" }}>
                            <td>{acc.id}</td>
                            <td>{acc.sessionName}</td>
                            <td>{acc.patientName}</td>
                            <td style={{ wordBreak: "break-word" }}>{acc.therapistName}</td>
                            <td>{new Date(acc.appointmentTime).toLocaleString()}</td>
                            <td>
                              <button
                                className="btn btn-sm btn-success"
                                onClick={handleOnClick.bind(this, "/CreateEntry/" + acc.patientId)}
                              >
                                Add Entry
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </MDBox>

                  <div className="text-right mx-3 my-4">
                    <Pagination
                      count={PaginationPages}
                      color="primary"
                      onChange={(e, number) => setPage(number)}
                      className="float-right"
                    />
                  </div>
                </Card>
              )}
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AccountingSessionWithNoPatientHistoryEntry;
